import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { AssignmentTypeService } from "../../services/AssignmentTypeService";
import { Selector } from "../Selectors/Selector";

export const AssignmentTypeSelect = ({
  id,
  selectHandler,
  assignmentTypes,
  label,
  selectedOptions,
  type,
  // comparableData,
  selectedAssignment,
  clear,
  size,
}) => {
  const { t } = useTranslation();
  const [types, setTypes] = useState([]);

  useEffect(() => {
    if (!assignmentTypes) {
      AssignmentTypeService.getAssignmentTypes().then((types) =>
        setTypes(
          types.map((assignmentType) => {
            return {
              id: assignmentType.id,
              title: assignmentType.name,
              name: assignmentType.name,
              label: assignmentType.name,
            };
          })
        )
      );
    }
  }, []);

  return (
    <Selector
      type={type}
      id={id || "assignment-selector"}
      label={label}
      assistiveText={t("assignment.assignmentTypeSelector")}
      selectHandler={selectHandler}
      options={assignmentTypes ? assignmentTypes : types}
      selectedItemId={selectedAssignment}
      selectedOptions={selectedOptions}
      clear={clear}
      size={size}
    />
  );
};
